import { render, staticRenderFns } from "./scope-card.vue?vue&type=template&id=590ad6ae&scoped=true"
import script from "./scope-card.vue?vue&type=script&lang=js"
export * from "./scope-card.vue?vue&type=script&lang=js"
import style0 from "./scope-card.vue?vue&type=style&index=0&id=590ad6ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590ad6ae",
  null
  
)

export default component.exports